import {
  Skeleton,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";

import { InfoOutlined } from "@mui/icons-material";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import MUIToolTip from "../../../Component/UI/MUIToolTip/MUIToolTip";
import { metricExplainations } from "../../../utils/constant";
import { extractDomain } from "../../../utils/helpers";
import { ReportScreenShot } from "../../Dashboard/common/MetricDetails";
import  DetailedTableModal   from "../BrandAuditMetricDetails"
import { DiscoveryContext } from "../discovery-context";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import Table, {
  StyledTableCell,
  StyledTableRow,
} from "./../../../Component/UI/Table/Table";
import classes from "./CoreAttributes.module.css";

const TABLE_HEADERS = [
  {
    id: "attr",
    name: "Brand Pillars",
  },
];

export default function CoreAttributes({ category, entity }) {
  const [error, setError] = useState();
  const discoveryCtx = useContext(DiscoveryContext);
  const abortControllerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
 

  function formatName(str) {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  function renderRows(rowItem, index) {
    return (
      <StyledTableRow key={index}>
        <StyledTableCell className={classes.attribute_headings}>
          {formatName(rowItem.name)}
        </StyledTableCell>
        {rowItem.scores.map((item, index) => {
          let color = "#dc3545";
          let rating = "low";
          if (item.score >= 7) {
            rating = "fair";
            color = "#2196F3";
          }
          if (item.score >= 9) {
            rating = "high";
            color = "#198754";
          }

          let sources = [];
          if (item?.sources) {
            sources = item.sources.map((source) => ({
              source: source,
              snippet: "",
            }));
          }

          return (
            <MUIToolTip
              key={index}
              title={item.explanation}
              additionalText={`${item.name} received a rating of ${item.score
                } out of 10, a ${rating} score in ${formatName(rowItem.name)}`}
              arrow
              disableAction
              llmSources={sources}
              showSources
              llm={discoveryCtx.state.selectedLLM}
              actionText="Add To Actions"
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -18],
                      },
                    },
                  ],
                },
              }}
            >
              <StyledTableCell
                style={{ color }}
                className={classes.attribute_score}
              >
                {item.score}
              </StyledTableCell>
            </MUIToolTip>
          );
        })}
      </StyledTableRow>
    );
  }

  function LoadingSkeletion() {
    return (
      <div className="p-3">
        <Skeleton variant="rectangular" height={30} />
        {Array(8)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              variant="rectangular"
              width={index % 2 === 0 ? "80%" : "97%"}
              key={index}
              className="my-3"
              height={20}
            />
          ))}
      </div>
    );
  }

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  useEffect(() => {
    if (
      (discoveryCtx?.core_attributes?.[discoveryCtx.primary_llm]?.[category] &&
        Object.keys(discoveryCtx?.core_attributes?.[discoveryCtx.primary_llm]?.[category]).length > 0)
      || discoveryCtx.state.id
    )
      return;
    // getCoreAttributes();


  }, [discoveryCtx.state.id]);

  function renderHeaders(showModalPop=showModal) {
    const headers = [
      ...TABLE_HEADERS,
      ...discoveryCtx.competitors['default'].map((item) => ({
        id: item.name,
        name: item.name,
      })),
      ...discoveryCtx.competitors[category].map((item) => ({
        id: item.name,
        name: item.name,
      })),
    ];
    const entityAndCompetitorData = [...discoveryCtx.competitors['default'], ...discoveryCtx.competitors[category]]
    return (
      <TableHead className={classes.table_head}>
        <TableRow>
          {headers.map((header, index) => {
            let ctxCompetitor = null;
            if (index !== 0) {
              if (index === 1) {
                ctxCompetitor = discoveryCtx.competitors['default'][0];
              } else {
                ctxCompetitor = discoveryCtx.competitors[category][index - 2];
              }
            }

            let domain = "";
            if (ctxCompetitor && ctxCompetitor?.domain) {
              domain = extractDomain(ctxCompetitor?.domain);
            }

            return (
              <TableCell key={index} className={index == 0 ? classes.table_head_cell_index : classes.table_head_cell}>
                <div className={classes.table_head_content}>
                  {index != 0 && (
                    <img
                      data-html2canvas-ignore
                      className={classes.table_head_logo}
                      src={`https://img.logo.dev/${domain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                    />
                  )}
                  <div
                    className={
                      index === 0
                        ? classes.table_head_text_comp
                        : classes.table_head_text
                    }
                  >
                    {/* {header.name} */}
                    <div className={classes.table_head_title}>
                      <span>
                        <Tooltip title={metricExplainations[header.name]}>
                          {header.name}
                        </Tooltip>
                      </span>
                      {index === 0 && !showModalPop && (
                        <MUIIconButton onClick={(showModal) => setShowModal(true)} id="brand_pillars">
                          <InfoOutlined />
                        </MUIIconButton>
                      )}
                    </div>
                  </div>
                </div>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }

  let coreAttributesData = [];
  let loading = true;
  const selectedLLM = discoveryCtx.state.selectedLLM;
  let coreAttributes = discoveryCtx?.core_attributes?.[selectedLLM]?.[category];
  let competitors = discoveryCtx?.competitors?.[category].map((item) => item.name);
  let brand = discoveryCtx?.competitors?.['default']?.[0].name;
  competitors.unshift(brand);
  if (
    coreAttributes &&
    Object.keys(coreAttributes).length > 0 &&
    coreAttributes?.summary
  ) {
    coreAttributesData = Object.keys(
      coreAttributes.category_averages
    ).map((item) => {
      const scores = coreAttributes.products.map((p) => ({
        name: p.name,
        score: p.attributes[item]?.score,
        explanation: p.attributes[item]?.explanation,
        sources: p.attributes[item]?.sources,
      }));

      return {
        name: item,
        scores: scores,
      };
    });
    loading = false;
  }

  return (
    <>
    <MUICard variant="elevated" elevation={0} className={classes.card}>
      {coreAttributesData &&
        coreAttributesData.length > 0 &&
        !loading &&
        !error && (
          <>
            <Table
              elevation={0}
              data={coreAttributesData}
              renderHeaders={() => renderHeaders()}
              render={renderRows}
            />
            <DetailedTableModal
              show={showModal}
              onClose={() => setShowModal(false)}
              data={coreAttributesData}
              headers={[discoveryCtx.entity, ...discoveryCtx.competitors[category].map((item) => item.name)]}
              renderHeaders={renderHeaders}
              formatName={formatName}
              classes={classes}
              pdfHeight={400}
              pdfTitle={`${entity}-Brand Pillars`}
            />
             <ReportScreenShot
              data={coreAttributesData}
              headers={[discoveryCtx.entity, ...discoveryCtx.competitors[category].map((item) => item.name)]}
              renderHeaders={renderHeaders}
              formatName={formatName}
              classes={classes}
            />
          </>

        )}
      {loading && !error && <LoadingSkeletion />}
      {error && (
        <div className={classes.error}>
          <ErrorView
            title={"Error fetching core attributes"}
            message={error}
            retry
          />
        </div>
      )}
    </MUICard>


  </>
  );
}

